import '@api-mock'
import '@/assets/scss/global.scss'

import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from '@/App.vue'
import i18n from '@/i18n'
import router from '@/router'
import { initGTM } from '@/utils/tracker.js'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

initGTM(app, router)

app.mount('#app')
